module.exports = __webpack_public_path__ + "main/assets/public/background-texture.94c4f9cbc2ce8104.gif";